import React from 'react';
import { IView } from 'interfaces/common';
import { IRoles } from 'interfaces/roles.interface';

const ViewFinishOnboarding: IView = {
  key: 'viewFinishOnboarding',
  title: 'tasks.taskCreation.taskBase',
  roles: [IRoles.ADMINISTRATOR, IRoles.SUPERIOR, IRoles.HR],
  view: React.lazy(() => import('./finish-onboarding-page')),
  path: '/pracownicy/zakoncz-onboarding/:id',
};

export default ViewFinishOnboarding;
